import { Box, Typography, Grid } from '@mui/material';
import { Surface } from '../../../components/primitives';
import ChartSection from '../shared/ChartSection';
import { fmtPct } from '../shared/formatters';

export default function AlphaByState({ data }) {
    if (!data || Object.keys(data).length === 0) return null;

    const sorted = Object.entries(data).sort((a, b) => b[1] - a[1]);
    const top10 = sorted.slice(0, 10);
    const bottom10 = sorted.slice(-10);

    const RankList = ({ items, startRank }) => (
        <Box>
            {items.map(([state, alpha], i) => (
                <Box key={state} sx={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    py: 0.75, borderBottom: i < items.length - 1 ? t => '1px solid ' + t.palette.custom.border.subtle : 'none',
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Typography sx={{ fontFamily: t => t.typography.fontFamilyMono, color: 'text.muted', width: 24, textAlign: 'right', fontSize: '0.8rem' }}>
                            {startRank + i}.
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary' }}>{state}</Typography>
                    </Box>
                    <Typography sx={{
                        fontFamily: t => t.typography.fontFamilyMono,
                        fontSize: '0.85rem', fontWeight: 600,
                        color: alpha >= 0 ? 'success.main' : 'error.main',
                    }}>
                        {fmtPct(alpha)}
                    </Typography>
                </Box>
            ))}
        </Box>
    );

    return (
        <ChartSection id="alpha-state" title="Which states' delegations trade best?" subtitle="Average alpha vs S&P 500 by state (members with 5+ trades)">
            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <Surface variant="subtle" padding={2}>
                        <Typography variant="overline" sx={{ color: 'success.main', display: 'block', mb: 1 }}>Top 10 States</Typography>
                        <RankList items={top10} startRank={1} />
                    </Surface>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Surface variant="subtle" padding={2}>
                        <Typography variant="overline" sx={{ color: 'error.main', display: 'block', mb: 1 }}>Bottom 10 States</Typography>
                        <RankList items={bottom10} startRank={sorted.length - 9} />
                    </Surface>
                </Grid>
            </Grid>
        </ChartSection>
    );
}
